import type { PropsWithChildren, ReactNode } from "react";

import { Card } from "#components/v2/Card";

import { StatCardContent } from "./StatCardContent";
import { StatCardTitle } from "./StatCardTitle";

export interface StatCardProps extends PropsWithChildren {
  title: string;
  message: string | ReactNode;
  description?: string;
  info?: string;
  menu?: ReactNode;
  className?: string;
}

export function StatCard({
  className,
  title,
  message,
  description,
  children,
  info,
  menu,
}: StatCardProps) {
  return (
    <Card className={className} variant="statCard">
      <div className="flex h-full flex-col">
        <div className="flex items-center justify-between gap-3">
          <StatCardTitle info={info} title={title} />
          {menu ? (
            <div className="flex h-6 w-6 flex-shrink-0 items-center justify-center">{menu}</div>
          ) : null}
        </div>

        {description ? <div className="text-sm mt-1">{description}</div> : null}

        <StatCardContent className="mt-auto" message={message}>
          {children}
        </StatCardContent>
      </div>
    </Card>
  );
}
